import React from 'react';
import { Modal, Button } from 'antd';
import { CloseOutlined, FullscreenOutlined } from '@ant-design/icons';
import StateGraphEditor from './StateGraphEditor';

interface StateGraphEditorModalProps {
  visible: boolean;
  onClose: () => void;
  projectId: string;
  agentId: string | null;
}

const StateGraphEditorModal: React.FC<StateGraphEditorModalProps> = ({
  visible,
  onClose,
  projectId,
  agentId,
}) => {

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onClose}
      footer={null}
      width="100vw"
      centered
      closable={false}
      maskClosable={false}
      style={{
        top: 0,
        height: '100vh',
        maxWidth: '100vw',
        margin: 0,
        padding: 0,
      }}
      styles={{
        body: {
          height: '100vh',
          padding: 0,
          overflow: 'hidden',
        },
        content: {
          height: '100vh',
          borderRadius: 0,
        }
      }}
    >
      {/* Custom Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        borderBottom: '1px solid #f0f0f0',
        background: '#ffffff',
        height: '64px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <FullscreenOutlined style={{ fontSize: '20px', color: '#1890ff' }} />
          <div>
            <h1 style={{ 
              margin: 0, 
              fontSize: '18px', 
              fontWeight: 600,
              color: '#262626'
            }}>
              AI Agent Workflow Editor
            </h1>
            <p style={{ 
              margin: 0, 
              fontSize: '14px', 
              color: '#8c8c8c'
            }}>
              {agentId 
                ? 'Edit agent workflow with drag-and-drop interface' 
                : 'Create new agent workflow with visual components'
              }
            </p>
          </div>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            size="middle"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px',
            }}
          />
        </div>
      </div>

      {/* Graph Editor Content */}
      <div style={{ 
        height: 'calc(100vh - 64px)',
        overflow: 'hidden',
        background: '#ffffff'
      }}>
        <StateGraphEditor 
          projectId={projectId}
          readonly={false}
          agentId={agentId}
        />
      </div>
    </Modal>
  );
};

export default StateGraphEditorModal;